export default "__VITE_ASSET__D6PfoP9w__"